import { Component, OnInit } from '@angular/core';
import { AuthService } from "../../services/auth.service";
import { SubHeaderService } from "../../core/services/sub-header.service";
import { SubHeader } from "../../core/models/sub-header.model";

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    standalone: false
})
export class LogoutComponent implements OnInit {

    message: string = "Terminating the current session";

    private subheader: SubHeader = new SubHeader({ title: "Home", buttons: [] });

    constructor(readonly auth: AuthService, readonly subHeaderService: SubHeaderService) { }

    ngOnInit() {
        this.subHeaderService.updateSubHeader(this.subheader); //necessary to make sure we don't accidentally show a remnant subheader during logout
        this.auth.logout();
  }

}
